import { julo } from '@julo-ui/react';

const TncContent = () => {
  return (
    <julo.article>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div
          style={{
            float: 'left',
            width: '100%',
            paddingBottom: '25px',
            fontWeight: 'bold',
          }}
        >
          1. Definisi
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          1.1
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          PT Julo Teknologi Finansial, selanjutnya disebut JULO, adalah
          perusahaan di bidang finansial dan teknologi yang menyediakan Layanan
          untuk mempertemukan Pemberi Pinjaman dengan Penerima Pinjaman, untuk
          melaksanakan pinjaman secara langsung atau peer-to-peer lending,
          melalui Aplikasi JULO pada smartphone Android.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          1.2
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Anda adalah Pemberi Pinjaman, Penerima Pinjaman, pengguna, pengunjung
          atau setiap orang yang menggunakan Aplikasi JULO.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          1.3
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Aplikasi JULO adalah aplikasi smartphone Android yang bisa diunduh
          oleh Anda yang menggunakan smartphone Android.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          1.4
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Layanan adalah pengadaan sarana melalui Aplikasi JULO milik PT Julo
          Teknologi Finansial yang digunakan untuk mempertemukan Pemberi
          Pinjaman dengan Penerima Pinjaman, untuk melaksanakan kegiatan
          pinjaman secara langsung atau peer-to-peer lending.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          1.5
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Penerima Pinjaman adalah Anda yang menggunakan Layanan Aplikasi JULO
          atas nama perseorangan, badan usaha mikro, kecil atau menengah, yang
          bermaksud untuk menerima pinjaman melalui Aplikasi JULO.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          1.6
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Pemberi Pinjaman adalah Anda yang menggunakan Layanan Aplikasi JULO
          atas nama perseorangan, badan usaha, institusi, perusahaan yang
          menyediakan dana sebagai Pinjaman, yang disalurkan oleh JULO ke
          Penerima Pinjaman atas persetujuan Pemberi Pinjaman melalui Aplikasi
          JULO.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          1.7
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Pinjaman adalah dana yang diberikan Pemberi Pinjaman kepada Penerima
          Pinjaman melalui JULO.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          1.8
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Konten Anda adalah data pribadi, segala materi dan informasi yang Anda
          berikan, unggah, publikasikan, sediakan, kirimkan dan tampilkan pada
          Aplikasi JULO.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          1.9
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Hukum adalah undang-undang, peraturan, surat keputusan dan kebijakan
          yang memiliki kekuatan hukum, baik di daerah, provinsi, wilayah,
          kotamadya, kabupaten, pusat maupun pemerintahan regional, otoritas
          gabungan pemerintahan dan swasta; baik dari pemerintah Republik
          Indonesia dan yuridiksi terkait lainnya, termasuk kementerian,
          departemen, komisi, biro, dewan, administratif dan/atau lembaga atau
          badan lainnya.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          1.10&nbsp;
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Surat Konfirmasi Rincian Transaksi Pendanaan adalah perjanjian pinjam
          meminjam antara Pemberi Pinjaman dan Penerima Pinjaman, dimana
          Penerima Pinjaman berjanji akan membayar kembali semua Pinjaman
          beserta bunga dalam kurun waktu yang telah disetujui kedua belah
          pihak.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div
          style={{
            float: 'left',
            width: '100%',
            paddingBottom: '25px',
            fontWeight: 'bold',
          }}
        >
          2. Layanan JULO
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          2.1&nbsp;
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Layanan JULO bersifat administratif dan berlaku sebagai yang
          mengadakan sarana untuk mempertemukan Pemberi Pinjaman dengan Penerima
          Pinjaman untuk melaksanakan kegiatan pinjam meminjam secara langsung
          atau peer-to-peer lending, yang belum diatur dan diawasi oleh OJK
          (Otoritas Jasa Keuangan) dan BI (Bank Indonesia).
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          2.2&nbsp;
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          JULO tidak memihak siapapun, baik Penerima Pinjaman maupun Pemberi
          Pinjaman, dalam perjanjian pinjam meminjam.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          2.3&nbsp;
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          JULO memegang wewenang tunggal dan absolut untuk menerima dan menolak
          Pemberi Pinjaman dan/atau Penerima Pinjaman. Apabila Anda ditolak,
          JULO tidak akan menyediakan Layanan atau kewajiban apapun kepada Anda.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          2.4&nbsp;
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Ketentuan Layanan JULO tunduk pada Hukum dan Syarat dan Ketentuan Umum
          ini. JULO tidak bertanggung jawab atas tindakan yang diambil oleh
          pihak manapun dalam rangka mematuhi Hukum dan Syarat dan Ketentuan
          Umum ini, kecuali memperoleh persetujuan terlebih dahulu dari pihak
          JULO.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          2.5&nbsp;
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          JULO tidak akan menyediakan layanan simpanan atau deposito dalam
          bentuk apapun, dan/atau layanan penitipan/penyimpanan, dan/atau
          mengadakan kegiatan perbankan, pasar modal atau kegiatan lainnya
          seperti yang diatur oleh OJK dan BI.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          2.6&nbsp;
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          Layanan yang disediakan oleh JULO dapat termasuk memfasilitasi
          Pinjaman dan/atau jenis layanan lain yang dapat JULO perkenalkan
          sewaktu-waktu.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '7%', paddingBottom: '25px' }}>
          2.7&nbsp;
        </div>
        <div
          style={{
            float: 'left',
            width: '89%',
            paddingRight: '2px',
            paddingLeft: '7px',
            paddingBottom: '25px',
          }}
        >
          PT Julo Teknologi Finansial didirikan berdasarkan Hukum Republik
          Indonesia dan merupakan badan hukum yang belum diatur dan/atau diawasi
          oleh OJK.
        </div>
      </div>
      <div
        style={{
          textAlign: 'left',
          marginLeft: 5,
          marginRight: 5,
          width: '98%',
        }}
        className='tnCContent'
      >
        <div style={{ float: 'left', width: '100%', paddingBottom: '25px' }}>
          Apabila terdapat pertentangan atau perbedaan antara Syarat dan
          Ketentuan Umum ini dan Perjanjian lainnya, maka yang berlaku adalah
          Perjanjian atau Syarat dan Ketentuan yang berlaku secara spesifik.
        </div>
      </div>
    </julo.article>
  );
};

export default TncContent;
